import React from 'react'
import PropTypes from 'prop-types'
import constants from '../../../lib/constants'
import _ from 'lodash'
import { Link } from 'react-router'
import { isDeviceActive } from '../../../lib/helpers'
import './HomeViewProvider.scss'
import 'react-select/dist/react-select.css'
import ResultModal from './ResultModal'

class HomeViewProvider extends React.Component {
  static defaultProps = {
    deviceHistory: [],
    loadDeviceHistory: _.noop,
    startJob: _.noop,
    user: null,
    jobs: {},
  }

  static propTypes = {
    deviceHistory: PropTypes.shape({}),
    loadDeviceHistory: PropTypes.func,
    startJob: PropTypes.func,
    user: PropTypes.shape({}),
    jobs: PropTypes.shape({}),
  }

  constructor (props) {
    super(props)
    this.state = {
      jobId: null
    }
  }

  componentDidMount () {
    const { loadDeviceHistory } = this.props
    loadDeviceHistory(constants.DEPLOYMENT_STATES.PRODUCTION)
  }

  startTest = (e, device, stripType = constants.STRIP_TYPES.WBC) => {
    const { startJob } = this.props
    startJob(device.device_string, stripType)
    .then((response) => {
      this.setState({
        jobId: response.data.job_id
      }, () => {
        $('#resultModal').modal({
          show: true
        })
      })
    })
  }

  showResultsModal = (jobId) => {
    this.setState({
      jobId
    }, () => {
      $('#resultModal').modal({
        show: true
      })
    })
  }

  hideAlert = () => {
    this.setState({
      showJobStartedAlert: false,
    })
  }

  render () {
    const { deviceHistory, jobs } = this.props
    const { jobId } = this.state

    const sortedDeviceHistory = _.sortBy(deviceHistory, (device) => {
      if (device.last_active) {
        return 0 - new Date(device.last_active).getTime()
      }
    })

    const filteredDeviceHistory = _.filter(sortedDeviceHistory, (dev) => dev.device_string)

    const deviceRows = _.map(filteredDeviceHistory, (device) => {
      const isActive = isDeviceActive(device)
      const runningJob = device.runningJobId ? jobs[device.runningJobId] : null
      return (
        <tr key={device.device_string}>
          <td><Link to={`/device/${device.device_string}`}>{device.device_string}</Link></td>
          <td>{new Date(device.last_active).toLocaleString()}</td>
          <td>
            <div className='btn-group' style={{ width: '100%' }}>
              <button
                type='button'
                className={`btn ${isActive ? 'btn-info' : 'btn-outline-info'} clickable run-button`}
                onClick={(e) => this.startTest(e, device)}
                data-toggle='modal'
              >
                Run
              </button>
              <button type='button' className='btn btn-outline-info dropdown-toggle dropdown-toggle-split' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>
                <span className='sr-only'>
                  Toggle Dropdown
                </span>
              </button>
              <div className='dropdown-menu'>
                <div
                  className='dropdown-item'
                  onClick={(e) => this.startTest(e, device, constants.STRIP_TYPES.WBC_CONTROL)}
                >
                  Control
                </div>
                <Link to={`/qc/${device.device_string}/create`}>
                  <div
                    className='dropdown-item'
                    >
                    QC
                  </div>
                </Link>
              </div>
            </div>
          </td>
          <td>
            <button
              type='button'
              className='btn btn-outline-secondary run-button'
              disabled={!runningJob}
              onClick={() => this.showResultsModal(device.runningJobId)}
              data-toggle='modal'
            >
              View Current Result
            </button>
          </td>
        </tr>
      )
    })

    return (
      <div>
        <div className='table-responsive' style={{ minHeight: '80vh' }}>
          <table className='table'>
            <thead className='thead-dark'>
              <tr>
                <th scope='col' className='device-column'>Device Id</th>
                <th scope='col' className='last-used-column'>Last Used</th>
                <th scope='col'>Run</th>
                <th scope='col'>Current Result</th>
              </tr>
            </thead>
            <tbody>
              {deviceRows}
            </tbody>
          </table>
        </div>
        <ResultModal job={jobs[jobId]} />
      </div>
    )
  }
}

export default HomeViewProvider



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeViewProvider.js